import Vue from 'vue';
import { getListingStatus, getSnapshotListing } from '../api';
import * as TYPES from './types';
import { checkSoldHousePreview } from '@/common/utils';
export default {
    // 从后端接口获取 listing status 并赋值
    async [TYPES.GET_LISTING_STATUS]({ commit }, payload = {}) {
        let ret = await getListingStatus(payload.data);
        commit({
            type: TYPES.SET_LISTING_STATUS,
            data: ret.data
        });
    },
    // 从后端接口获取 listing 并赋值
    async [TYPES.GET_LISTING]({ commit, dispatch, rootState }, payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        let page = rootState.page?.page || {};
        let ret = await getSnapshotListing(params, page);
        commit({
            type: TYPES.SET_LISTING,
            data: ret.listings
        });
        // 设置分页
        commit({
            type: TYPES.SET_TOTAL_PAGE,
            data: ret.totalPage
        });
        // 补图
        dispatch(TYPES.ADD_SOLD_PICTURE);
    },
    // add picture
    async [TYPES.ADD_SOLD_PICTURE]({ state }) {
        const { listing } = state;
        checkSoldHousePreview({ listings: listing }, Vue.set);
    }
};
